import { Validators } from '@angular/forms';
import {
    ErrorMessages,
    GenericCameraSettings,
    GroupEnum,
    InputType,
    PhotoSizeEnum,
    PropertyNames,
    RenderType,
    WifiMode,
    WifiModePropertyNames
} from './models';



export const MatrixProps: GenericCameraSettings[] = [
    //WIFI GLobal Settings//
    {
        groupId: GroupEnum.Wi_Fi_Global_Settings,
        orderindex: 1,
        propertyName: PropertyNames.WifiMode[0],
        displayName: PropertyNames.WifiMode[1],
        render: true,
        value: 1,
        defaultValue: 1,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            {
                text: 'Off',
                value: 0
            },
            {
                text: 'On',
                value: 1
            }
        ],
        size: 4,
        effects: [
            {
                propertyNames: WifiModePropertyNames,
                givenValues: [1],
                disabled: false
            },
            {
                propertyNames: WifiModePropertyNames,
                givenValues: [0],
                disabled: true
            }
        ]
    },
    {
        groupId: GroupEnum.Wi_Fi_Global_Settings,
        orderindex: 2,
        propertyName: PropertyNames.WifiConnectionMode[0],
        displayName: PropertyNames.WifiConnectionMode[1],
        render: true,
        value: 1,
        disabled: true,
        defaultValue: WifiMode.Station,
        inputType: InputType.Number,
        size: 4,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: 'Station', value: WifiMode.Station },
            { text: 'Wi-Fi direct', value: WifiMode.WifiDirect }
        ],
        effects: [
            {
                givenValues: [WifiMode.Station],
                propertyNames: [PropertyNames.Ssid[0], PropertyNames.STPassword[0]],
                disabled: false,
            },
            {
                givenValues: [WifiMode.WifiDirect],
                propertyNames: [PropertyNames.Ssid[0], PropertyNames.STPassword[0]],
                disabled: true,
            },
            {
                givenValues: [WifiMode.WifiDirect],
                propertyNames: [PropertyNames.WifiDirectPin[0]],
                disabled: false
            },
            {
                givenValues: [WifiMode.Station],
                propertyNames: [PropertyNames.WifiDirectPin[0]],
                disabled: true
            }
        ]
    },
    ////////////////////////
    //Network Configuration//
    {
        groupId: GroupEnum.Network_Configuration,
        orderindex: 1,
        propertyName: PropertyNames.Ssid[0],
        displayName: PropertyNames.Ssid[1],
        render: true,
        value: '',
        defaultValue: '',
        inputType: InputType.Text,
        size: 4,
        renderType: RenderType.TextBox,
        validations: [Validators.pattern('^[ -~]+$'), Validators.required],
        validationErrorMessages: {
            pattern: ErrorMessages.Ssid_Pattern,
            required: ErrorMessages.Ssid_required
        }
    },
    {
        groupId: GroupEnum.Network_Configuration,
        orderindex: 2,
        propertyName: PropertyNames.STPassword[0],
        displayName: PropertyNames.STPassword[1],
        render: true,
        value: '',
        defaultValue: '',
        inputType: InputType.Password,
        size: 4,
        renderType: RenderType.TextBox,
        validations: [Validators.pattern('^[ -~]{8,32}$'), Validators.required],
        validationErrorMessages: {
            pattern: ErrorMessages.STPassword_Pattern,
            required: ErrorMessages.STPassword_Required
        }
    },
    ////////////////////////
    //NOTIFICATIONS//
    {
        groupId: GroupEnum.Notifications,
        orderindex: 1,
        propertyName: PropertyNames.BeepSound[0], // Camera Notification
        displayName: PropertyNames.BeepSound[1],
        render: true,
        value: 1,
        defaultValue: 1,
        size: 4,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: 'Off', value: 0 },
            { text: 'Beep', value: 1 }
        ]
    },
    {
        groupId: GroupEnum.Notifications,
        orderindex: 2,
        propertyName: PropertyNames.RecordingNotification[0],
        displayName: PropertyNames.RecordingNotification[1],
        render: true,
        value: 0,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: 'Off', value: 0 },
            { text: 'Beep every 5 secs', value: 1 },
            { text: 'Beep every 10 secs', value: 2 },
            { text: 'Beep every 15 secs', value: 3 },
            { text: 'Beep every 30 secs', value: 4 },
            { text: 'Beep every 60 secs', value: 5 }
        ],
        size: 4
    },

    /////////////////
    //Low Light Recording
    /////////////////
    {
        groupId: GroupEnum.Low_light_recording,
        orderindex: 1,
        propertyName: PropertyNames.IRMode[0],
        displayName: PropertyNames.IRMode[1],
        render: true,
        value: 3,
        size: 4,
        defaultValue: 3,
        inputType: InputType.Text,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: 'Off', value: 0 },
            // {text: 'Manual', value: 1},
            { text: 'During recording', value: 2 },
            { text: 'Auto', value: 3 }
        ]
    },
    {
        groupId: GroupEnum.Low_light_recording,
        orderindex: 2,
        propertyName: PropertyNames.IRCUTSensitivity[0],
        displayName: PropertyNames.IRCUTSensitivity[1],
        render: true,
        value: 5,
        size: 4,
        defaultValue: 5,
        inputType: InputType.Number,
        renderType: RenderType.Slider,
        min: 0,
        max: 10,
        step: 1
    },
    //////////////////////////////////
    //Recording Settings//
    {
        groupId: GroupEnum.Recording_Settings,
        orderindex: 1,
        propertyName: PropertyNames.RecordingSize[0],
        displayName: PropertyNames.RecordingSize[1], // Recording Resolution
        render: true,
        value: 5,
        size: 4,
        defaultValue: 5,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: '1920*1080', value: 5 },
            // {text: '1920X1080@30fps', value: 6},
            { text: '1280*720', value: 10 },
            // {text: '1280X720@30fps', value: 11},
            { text: '848*480', value: 13 }
        ]
    },
    {
        groupId: GroupEnum.Recording_Settings,
        orderindex: 2,
        propertyName: PropertyNames.RecordingQuality[0],
        displayName: PropertyNames.RecordingQuality[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: 'High', value: 0 },
            { text: 'Medium', value: 1 },
            { text: 'Low', value: 2 }
        ]
    },
    {
        groupId: GroupEnum.Recording_Settings,
        orderindex: 3,
        propertyName: PropertyNames.RecordingTime[0],
        displayName: PropertyNames.RecordingTime[1],
        render: true,
        value: 4,
        size: 4,
        defaultValue: 4,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: '5 mins', value: 4 },
            { text: '10 mins', value: 5 },
            { text: '15 mins', value: 6 }
        ]
    },
    //////////////////////
    //Pre and Post Recording//
    {
        groupId: GroupEnum.Pre_and_Post_Recording,
        orderindex: 1,
        propertyName: PropertyNames.PreRecordingTime[0],
        displayName: PropertyNames.PreRecordingTime[1],
        render: true,
        value: 0,
        size: 4,
        defaultValue: 0,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: 'Off', value: 0 },
            { text: '5 secs', value: 1 },
            { text: '10 secs', value: 2 },
            { text: '20 secs', value: 3 },
            { text: '30 secs', value: 4 },
            { text: '60 secs', value: 5 }
        ]
    },
    //////////////////////////
    //Image Quality//
    {
        groupId: GroupEnum.Image_Quality,
        orderindex: 2,
        propertyName: PropertyNames.PhotoSize[0],
        displayName: PropertyNames.PhotoSize[1],
        render: true,
        value: 4,
        size: 4,
        defaultValue: 4,
        inputType: InputType.Number,
        renderType: RenderType.Dropdown,
        renderTypeValues: [
            { text: '16 MP', value: PhotoSizeEnum.PHOTO_SIZE_16M },
            { text: '12 MP', value: PhotoSizeEnum.PHOTO_SIZE_12M },
            { text: '8 MP', value: PhotoSizeEnum.PHOTO_SIZE_8M },
            { text: '4 MP', value: PhotoSizeEnum.PHOTO_SIZE_4M }
        ]
    }
    //////////////////
];
